<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-0">
    <v-expansion-panel-header
      id="rec_pub_recs_req"
      @click="onExpansionPanelClick"
      class="accent white-text text-body2 text-md-h6"
      >SUBMIT A PUBLIC RECORDS REQUEST
      <template v-slot:actions>
        <v-icon color="white" x-large> $expand </v-icon>
      </template></v-expansion-panel-header
    >
    <v-expansion-panel-content color="grey lighten-5">
      <v-card shaped class="mt-4">
        <v-card-title>
          <h4>To submit a public records request, Click on the link below:</h4>
        </v-card-title>
        <v-card-text>
          <!-- jlm 4/1/2025 Mina Almario -->
          <a href="https://reno.govqa.us/WEBAPP/_rs/" target="_blank"
            >City of Reno Public Records Portal</a
          >
          <br />
          <small
            >You will be taken away from this page into a new browser
            tab.</small
          >
        </v-card-text>
      </v-card>
      <!-- jlm 4/1/2025 Mina Almario -->
      <!-- <v-card shaped class="mt-4">
        <v-card-title>
          <h4>A Guide to Submitting a public records request.</h4>
        </v-card-title>
        <v-card-text>
          <a class="mt-3" href="/guide">OneRequest Customer User Guide</a>
        </v-card-text>
      </v-card> -->
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style lang="scss" scoped>
@import "../scss/site.scss";
border-img {
  border: 1px solid black;
}
.div-login-page-img {
  margin: 0;
}
.letter_img {
  width: 100%;
  margin-left: 0 !important;
}
.login-page-img {
  width: 100%;
  margin-left: 0 !important;
}
p {
  font-weight: 600;
  padding: 12px;
}
a {
  color: blue;
}
a:visited {
  color: rgb(2, 2, 32);
}
.bcs-expansion-content {
  color: black;
}
.basic-interior-card {
  min-height: 100px;
}
@media (min-width: 768px) {
  .login-page-img {
    max-width: 300px;
  }
  .letter_img {
    max-width: 436px;
  }
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "pub_recs_req",
  mixins: [bus_common],
  data: function () {
    return {
      isActive1: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
